import { famousScenes } from '@/mocks/animeData';

export default function FamousScenes() {
  return (
    <section id="scenes" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-700">
            <i className="ri-star-smile-line"></i>名场面盘点
          </span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
            高能名场面，一次看个够
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
            每一帧都值得反复回味的瞬间，按播出顺序盘点第一季最炸的五场戏。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5">
          {famousScenes.map((scene, i) => (
            <article
              key={scene.rank}
              className="group overflow-hidden rounded-3xl bg-background-50 lg:odd:translate-y-4"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={scene.image}
                  alt={`名场面${scene.rank}：${scene.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 font-heading text-base text-background-50">
                  {scene.rank}
                </span>
                <span className="absolute right-3 top-3 whitespace-nowrap rounded-full bg-foreground-950/60 px-2 py-0.5 text-[11px] text-foreground-50 backdrop-blur">
                  {scene.episode}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base text-foreground-950 md:text-lg">
                  {scene.title}
                </h3>
                <p className="mt-2 line-clamp-3 text-xs leading-relaxed text-foreground-600 md:text-sm">
                  {scene.desc}
                </p>
                <div className="mt-3 inline-flex items-center gap-1 text-xs font-bold text-primary-600">
                  围观现场 <i className="ri-play-circle-line"></i>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}